export default "__VITE_ASSET__CwPsmrWN__"